/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu-down': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7 10l5 5 5-5H7z"/>'
  }
})
